import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=2ee9ada0&scoped=true&"
import script from "./ChangePass.vue?vue&type=script&lang=ts&"
export * from "./ChangePass.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePass.vue?vue&type=style&index=0&id=2ee9ada0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9ada0",
  null
  
)

export default component.exports